import { UiContextMenuTheme } from '@nx-frontend/shared/types';

export const themeClassesMap = {
  [UiContextMenuTheme.LIGHT]: {
    menu: 'text-neutral-800 bg-white border-neutral-100 drop-shadow-ctxmenulight',
    subMenu: 'text-neutral-800 bg-white border-neutral-100',
    item: 'hover:bg-neutral-100',
  },
  [UiContextMenuTheme.DARK]: {
    menu: 'text-gray-800 bg-gray-200 border-gray-200',
    subMenu: 'text-gray-800 bg-white border-gray-200',
    item: 'hover:bg-white',
  },
};
